module.exports = __webpack_public_path__ + "img/jxzy.00a60cea.png";